<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        รายชื่อลูกค้าไม่ทำสัญญา
      </div>
      <v-spacer></v-spacer>

    </v-layout>
    <v-divider class="my-2"></v-divider>
    <filterCustomer :isfromNew="isfromNew" v-on:returnDessert="clickReturn" />
    <!-- <v-layout class="mb-n3">
      <v-btn color="white excel-border" elevation="0" light>
        <v-icon left>mdi-printer</v-icon>ดาวน์โหลด excel
      </v-btn>
    </v-layout>
    <v-row>
      <v-col></v-col>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>-->
    <v-data-table :headers="headers" :items="getIndex" :search="search">
      <template v-slot:item.STATUS="{ item }">
        <CustomerStatus :TableData="item" v-on:returnDessert="clickReturn" ></CustomerStatus>
      </template>

      <template v-slot:item.actions="{ item }">
        <TableMenuCustomer :TableData="item" :whichPage="'cancel_cus'"></TableMenuCustomer>
      </template>

      <!-- <template
        v-slot:item.CONTRACT_START_DATE="{ item }"
      >{{ contract_expier(item.CONTRACT_START_DATE,item.CONTRACT_END_DATE) }}</template>
      <template v-slot:item.CONTRACT_END_DATE="{ item }">{{ item.CONTRACT_END_DATE | thdate }}</template> -->

      <template v-slot:no-data>
        <v-btn color="info" @click="initialize">
          <v-icon left>mdi-refresh</v-icon>รีเฟรชข้อมูล
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import TableMenuCustomer from '../../components/TableMenuCustomer'
import CustomerStatus from '../../components/CustomerStatus'
import filterCustomer from '../../components/filterCustomer'
export default {
  components: {
    TableMenuCustomer,
    CustomerStatus,
    filterCustomer
  },
  data() {
    return {
      isfromNew:false,
      search: "",
      singleSelect: false,
      selected: [],
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: false,
          value: "index",
        },
        {
          text: "รายชื่อ",
          align: "start",
          sortable: false,
          value: "CUSTOMER_NAME",
        },
        { text: "ชื่อติดต่อ", value: "PROVIDER_NAME" },
        { text: "เบอร์โทร", value: "PROVIDER_PHONE" },

        { text: "ประเภท", value: "CUSTOMER_TYPE" },
        { text: "กำหนดวันเก็บขน", value: "PROVIDER_EMAIL" },
        { text: "สถานะ", value: "STATUS", sortable: false, width: '120' },
        { text: "การจัดการ", value: "actions", width: '90', sortable: false },
      ],
      desserts: [],
    };
  },

  computed: {
    // count index in table and chang date format
    getIndex() {
      return this.desserts.map((item, index) => ({
        ...item,
        index: index + 1,
        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
    //   listNew() {
    //     this.listOldcustomer();
    //   }
  },
  created() {
    this.listOldcustomer();
    //this.list_c_period();
  },
  methods: {
    initialize() {
      this.listOldcustomer();
    },
    insert_customer() {
      this.$router.push({ path: "/newCustomer/add-newCustomer" });
      this.$store.commit("CustomerDetail/SET_IS_EDIT", "Admin");
    },
    deleteItem(item) {
      const _this = this;
      this.$token_api
        .delete("/delete-Customer", {
          data: { CON_ID: item.CUSTOMER_ID },
        })
        .then((response) => {
          _this.listOldcustomer()
          this.$swal("ลบลูกค้า", "ลูกค้าเรียบร้อย", "question");
        })
        .catch((err) => { });

    },
    listOldcustomer() {
      this.$token_api
         .post("/list-all-oldCustomer",{STATUS:'ยกเลิก'})
        .then((response) => {
          let x = response.data.data;
          this.desserts = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clickReturn(val){
      this.desserts = val
    }
  },
};
</script>